import { render, staticRenderFns } from "./shadow.vue?vue&type=template&id=686490ac&scoped=true&"
import script from "./shadow.vue?vue&type=script&lang=js&"
export * from "./shadow.vue?vue&type=script&lang=js&"
import style0 from "./shadow.vue?vue&type=style&index=0&id=686490ac&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "686490ac",
  null
  
)

export default component.exports